import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentSearches = ({ recentSearches }) => {
  const navigate = useNavigate();

  const executeSearch = (search) => {
    const params = new URLSearchParams();
    if (search?.location) params?.set('location', search?.location);
    if (search?.propertyType) params?.set('type', search?.propertyType);
    if (search?.minPrice) params?.set('minPrice', search?.minPrice);
    if (search?.maxPrice) params?.set('maxPrice', search?.maxPrice);
    if (search?.bedrooms) params?.set('bedrooms', search?.bedrooms);
    
    navigate(`/property-search-browse?${params?.toString()}`);
  };

  if (recentSearches?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Recent Searches</h2>
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Search" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground mb-4">No recent searches</p>
          <Button
            variant="outline"
            onClick={() => navigate('/property-search-browse')}
            iconName="Search"
            iconPosition="left"
          >
            Start Searching
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Recent Searches</h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/property-search-browse')}
          iconName="Plus"
          iconPosition="left"
        >
          New Search
        </Button>
      </div>
      <div className="space-y-3">
        {recentSearches?.slice(0, 4)?.map((search) => (
          <div
            key={search?.id}
            className="flex items-center justify-between p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer"
            onClick={() => executeSearch(search)}
          >
            <div className="flex-1">
              <div className="flex items-center space-x-2 mb-1">
                <Icon name="MapPin" size={14} className="text-muted-foreground" />
                <span className="font-medium text-foreground">{search?.location}</span>
              </div>
              <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                {search?.propertyType && (
                  <span className="capitalize">{search?.propertyType}</span>
                )}
                {search?.priceRange && (
                  <span>{search?.priceRange}</span>
                )}
                {search?.bedrooms && (
                  <span>{search?.bedrooms}+ beds</span>
                )}
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                {search?.resultsCount} properties found • {search?.searchDate}
              </p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              iconName="RotateCcw"
              onClick={(e) => {
                e?.stopPropagation();
                executeSearch(search);
              }}
            >
              Repeat
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentSearches;